import { Design } from '@/types';
import { getParams } from '@/utils/params';
import { fetchFromApiSigned } from './fetchFromApi';
import { setLookupIdAsId } from './setLookupIdAsId';

export const fetchDesignForUser = (designId: string, signal?: AbortSignal) =>
  fetchFromApiSigned<Design>(
    `users/${getParams().userId || getParams().contextId}/designs/${designId}`,
    { fullData: true },
    {
      signal,
      credentials: 'include',
    }
  ).then(setLookupIdAsId);
